"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const recoil_1 = require("recoil");
const settlementRequestDataState_1 = __importDefault(require("./settlementRequestDataState"));
const userInfoState_1 = __importDefault(require("@/common/components/NavHeader/userInfoState"));
const showCompanyRegisterDialogState_1 = __importDefault(require("@/common/components/CompanyRegisterDialog/showCompanyRegisterDialogState"));
const CompanyRegisterDialog_1 = __importDefault(require("@/common/components/CompanyRegisterDialog"));
const _1 = require(".");
function default_1({ setValue, }) {
    const { channel_id } = (0, recoil_1.useRecoilValue)(userInfoState_1.default);
    const [{ user_id: userId }, setSettlementRequestData] = (0, recoil_1.useRecoilState)(settlementRequestDataState_1.default);
    const [showCompanyRegisterDialog, setShowCompanyRegisterDialog] = (0, recoil_1.useRecoilState)(showCompanyRegisterDialogState_1.default);
    const closeCompanyRegisterDialog = () => setShowCompanyRegisterDialog(false);
    const onCompanyInfoFetchSuccess = (fetchData) => {
        const { company_number, company_post_code, company_name, company_seller_publish_agree_items } = fetchData;
        const isSellerPublishAgree = company_seller_publish_agree_items.some(item => item.id === channel_id);
        setSettlementRequestData(prev => (Object.assign(Object.assign({}, prev), { company_number,
            company_post_code,
            company_name, channel_company_seller_publish_agree: isSellerPublishAgree })));
    };
    const onCompanyInfoRegisterSuccess = (registerData) => {
        const { company_number, company_post_code, company_name } = registerData;
        const updates = {};
        !!company_number && Object.assign(updates, { company_number });
        !!company_post_code && Object.assign(updates, { company_post_code });
        !!company_name && Object.assign(updates, { company_name });
        setSettlementRequestData(prev => (Object.assign(Object.assign(Object.assign({}, prev), updates), { channel_company_seller_publish_agree: true })));
        setValue('tax_type', 2);
    };
    const onCompanyInfoDeleteSuccess = () => {
        (0, _1.invalidateSettlementCompanyData)({ setSettlementRequestData, setValue });
        closeCompanyRegisterDialog();
    };
    return ((0, jsx_runtime_1.jsx)(CompanyRegisterDialog_1.default, { open: showCompanyRegisterDialog, closeDialog: closeCompanyRegisterDialog, userId: userId, onCompanyInfoFetchSuccess: onCompanyInfoFetchSuccess, onCompanyInfoRegisterSuccess: onCompanyInfoRegisterSuccess, onCompanyInfoDeleteSuccess: onCompanyInfoDeleteSuccess }));
}
exports.default = default_1;
